import { render, staticRenderFns } from "./TableCompanies.vue?vue&type=template&id=530506c5&scoped=true&"
import script from "./TableCompanies.vue?vue&type=script&lang=js&"
export * from "./TableCompanies.vue?vue&type=script&lang=js&"
import style0 from "./TableCompanies.vue?vue&type=style&index=0&id=530506c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530506c5",
  null
  
)

export default component.exports